<template>
  <div>
    <div class="container">
        <div class="fill-height downloadContent">
          <img src="/static/images/bg-download-bilibili.png">
          <div class="download" @click="download()"></div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "download_bilibili",
  methods: {
    download() {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf("android") != -1;
      const isIos = ua.indexOf("iphone") != -1 || ua.indexOf("ipad") != -1;
      if (isAndroid) {
        location.href = "https://app.zuidie.net/android/app-release.last.apk";
      }
      if (isIos) {
        location.href = "https://apps.apple.com/cn/app/%E5%85%94u/id6479624182";
      }
    },
  },
};
</script>

<style scoped>
.downloadContent {
  position: relative;
}
.download {
  position: absolute;
  width: 100%;
  height: 20%;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/downloadBilibili/index.vue